import React from 'react';
import {
    Box,
    FormControlLabel,
    makeStyles,
    Radio,
    Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Link } from '@klp/design/index';
import type { Leverandorvurdering } from '@klp/leverandor/types';
import { KlpFontVariant } from '@klp/design/Theme';

const useStyles = makeStyles((theme) => ({
    processItem: {
        padding: theme.spacing(1),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(1),
        '&:last-child': {
            marginBottom: 0,
        },
    },
    processDetails: {
        fontSize: KlpFontVariant.small.fontSize,
        color: theme.palette.text.secondary,
    },
}));

type VurderingListItemProps = {
    vurdering: Leverandorvurdering;
    value: string | undefined;
    onSuperofficeIdClick: (
        contactId?: string,
    ) => (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const VurderingListItem: React.FC<VurderingListItemProps> = ({
    vurdering,
    value,
    onSuperofficeIdClick,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box className={classes.processItem}>
            <FormControlLabel
                value={value}
                control={<Radio color="primary" />}
                label={
                    <Box>
                        <Link
                            klpTypographyVariant="small"
                            data-cy="Leverandor__SuperofficeLink"
                            klpColor="main"
                            onClick={onSuperofficeIdClick(
                                vurdering.superOfficeContactId,
                            )}
                        >
                            {vurdering.navn ?? t('general.unknown')}
                        </Link>
                        <Typography variant="body1" />
                        <Box className={classes.processDetails}>
                            <Box>
                                {t(
                                    'leverandor.createLeverandor.superOffice.companyId',
                                )}
                                : {vurdering.superOfficeContactId}
                            </Box>
                            {vurdering.klassifiseringBeskrivelse && (
                                <Box>
                                    {t(
                                        'leverandor.createLeverandor.superOffice.klassifisering',
                                    )}
                                    : {vurdering.klassifiseringBeskrivelse}
                                </Box>
                            )}
                        </Box>
                    </Box>
                }
            />
        </Box>
    );
};
